import './App.css';
import { Header } from './component/header';
import { Cover } from './component/cover';
import { Footer } from './component/footer';
import { Navigations } from './component/navigations';
import { useEffect, useState } from 'react';
import services from './services';
import { Subscription } from './component/subscription';

function App({ names }) {

  const [assets, setAssets] = useState([])
  const [multiSubscription, setMultiSubscription] = useState()
  const [showMultiSubscription, setShowMultiSubscription] = useState(false)
  const [assetsLoadingMessage, setAssetsLoadingMessage] = useState('')


  useEffect(() => {
    setAssetsLoadingMessage('Checking for the assets ...')
    services.getAssets()
      .then(({ data }) => {
        setAssets(data.sort((a, b) => a.order - b.order))
      })
      .catch(console.log).finally(_ => setAssetsLoadingMessage(''))
  }, [])


  return (
    <div className="App">

      <Header
        className="header"
        names={names}
        setShowMultiSubscription={setShowMultiSubscription}
        multiSubscription={multiSubscription} assets={assets}
      />

      <main>
        {
          showMultiSubscription && multiSubscription ?
            <Subscription
              data={multiSubscription}
              setShowMultiSubscription={setShowMultiSubscription}
              setAssets={setAssets}
            />
            : null
        }
        <Cover />
        <Navigations assets={assets} assetsLoadingMessage={assetsLoadingMessage} />
        <Footer />
      </main>
    </div>
  );
}


export default App;
